<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important; ">
    <div class="d-flex align-items-center mb-1">
<el-form inline ref="form" :model="searchform">

        

          <el-form-item class="mb-0">
             <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:150px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
          


       
         
          <el-form-item class="mb-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button> 
          </el-form-item>
      </el-form>
   <el-select v-model="admin_id" v-if="this.userid=='admin'"  style="width: 100px;" class="ml-2 mr-2" size="mini" @change="adminChange($event)">
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
	<el-button type="success" size="mini" @click="openUserModel(false)">{{$t('searchText.회원생성')}}</el-button>
  <el-button type="primary" size="mini"  @click="bonOpen(1,'','1')">{{$t('searchText.머니충환전')}}</el-button>
</div>
<el-table
        :data="data"
        row-key="mem_id"
        default-expand-all
        :tree-props="{children: 'users'}"
        v-loading="loading"
        border
        class="memlistTable"
        @sort-change='tableSortChange'
        :empty-text="$t('tableText.데이타가없습니다')"  @row-click="rowClick"  :highlight-current-row="true"
      >
        <el-table-column
          type="index"
          width="50" align="center" label="ID">
        </el-table-column>

        <el-table-column :label="$t('nav.아이디')"  prop="mem_id" align="left">
          <template slot-scope="scope">
          {{ scope.row.mem_id}}</template>
        </el-table-column>

         <el-table-column  align="right" width="45">
            <template slot-scope="scope">
                <span v-if="scope.row.mem_id==scope.row.m_code" class="bg-success text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;background:#3e3e3e !important">MST</span>
              <span v-if="scope.row.mem_id==scope.row.s_code" class="bg-success text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px;background:#e54747 !important">{{$t('msg.본사')}}</span>
           <span v-if="scope.row.mem_id==scope.row.b_code" class="bg-success text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.부본')}}</span>
            <span v-if="scope.row.mem_id==scope.row.a_code" class="bg-primary text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.총판')}}</span>
            <span v-if="scope.row.mem_id==scope.row.c_code " class="bg-warning text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.매장')}}</span>
             <span v-if="scope.row.mem_id!=scope.row.a_code && scope.row.mem_id!=scope.row.b_code && scope.row.mem_id!=scope.row.c_code && scope.row.mem_id!=scope.row.s_code && scope.row.mem_id!=scope.row.m_code" class="bg-info text-white mr-1" style="border-radius:3px;display:inline-block;padding:2px 4px;line-height:18px">{{$t('msg.유저')}}</span></template>
        </el-table-column>


        <el-table-column :label="$t('msg.가입경로')" prop="" align="center">
            <template slot-scope="scope">{{ scope.row.m_code}} {{ scope.row.s_code}} {{ scope.row.b_code}}-{{ scope.row.a_code}}-{{ scope.row.c_code}}</span></template>
        </el-table-column>

        <el-table-column :label="$t('msg.닉네임')" prop="mem_name" align="center">
          <template slot-scope="scope"><span>{{ scope.row.mem_name}}</span></template>
        </el-table-column>


          <template v-if="this.aid!='soft10'">
         <el-table-column :label="$t('msg.게임머니')" prop="mem_cash"  align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.mem_cash)}}</template>
        </el-table-column>
        <el-table-column :label="$t('msg.이벤트머니')" prop="mem_eventmoney" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.mem_eventmoney)}}</template>
        </el-table-column>

        <el-table-column v-if="this.sitetype==='3'"  :label="$t('msg.롤링머니')" prop="mem_ing" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.mem_ing)}}</template>
        </el-table-column>
      </template>

      <template v-if="this.aid=='soft10'">

         <el-table-column :label="$t('msg.알잔액')" prop="mem_cash"  align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(1,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_cash)}}</span></template>
        </el-table-column>
        
         <el-table-column :label="$t('msg.카슬머니')" prop="api_money"  align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(6,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.api_money)}}</span></template>
        </el-table-column>
        <el-table-column :label="$t('msg.카슬롤링')" prop="mem_eventmoney" align="center">
          <template slot-scope="scope"><span class="text-primary" @click="bonOpen(2,scope.row.mem_id,'1')"  style="cursor:pointer">{{ formatMoney(scope.row.mem_eventmoney)}}</span></template>
        </el-table-column>

        <template v-if="this.power=='1'">
        <el-table-column  :label="$t('msg.파워머니')" prop="power_cash"  align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.power_cash)}}</template>
        </el-table-column>
        <el-table-column :label="$t('msg.파워롤링')"  prop="power_ecash" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.power_ecash)}}</template>
        </el-table-column></template>


        
      </template>


        <el-table-column  :label="$t('msg.입금')" prop="in_money" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.in_money)}} </template>
        </el-table-column>

        <el-table-column :label="$t('msg.출금')"  prop="out_money" align="center">
          <template slot-scope="scope">{{ formatMoney(scope.row.out_money)}}</template>
        </el-table-column>
        
        <el-table-column :label="$t('msg.가입일')" prop="mem_regdate" align="center">
          <template slot-scope="scope">{{ scope.row.mem_regdate}}</template>
        </el-table-column>
        <el-table-column
           align="center"
          prop="memState"
          :label="$t('msg.레밸')">
          <template slot-scope="scope">
          <el-select  :placeholder="$t('status.선택')" v-model="scope.row.memState" size="mini" @change="changeOptions(scope)">
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>
         <el-table-column :label="$t('status.편집')" prop="mem_regdate" align="center">
         <template slot-scope="scope">
        
           <el-button-group>
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="openModel(scope.row.mem_id)"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteAll(scope)"></el-button>
           </el-button-group>
        
      </template>
        </el-table-column>
       
      </el-table>
        <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>
       
        <el-dialog
          :title="$t('tableText.추가')"
          :visible.sync="creatModel" :width="layoutWidth1" :close-on-click-modal ="false">

          <el-form ref="userform" :model="userform" label-width="100px" v-loading="loading" :rules="rules">
           
              <el-radio-group v-model="radio" @change="radioChange">
                 <div class="d-flex">
            <el-form-item :label="$t('tableText.총판선택')" prop="a_code" class="mb-0 formItem2 mr-2">
               <el-radio  class="mr-0 mb-0" label="1" style="margin-left: -30px;margin-top: 2px;">
                 <el-select v-model="userform.a_code" :placeholder="$t('searchText.타이틀선택')" size="mini" prop="boss"  :disabled="disabled1"  style="width: 100px;">
               <el-option
                      v-for="item in bubonlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
               </el-radio>
              
            </el-form-item>
            <el-form-item :label="$t('searchText.매장선택')" prop="c_code" class="mb-0 w-50 formItem2">
               <el-radio class="mr-0 mb-0" label="2" style="margin-left: -30px;margin-top: 2px;">
                  <el-select v-model="userform.c_code" :placeholder="$t('searchText.타이틀선택')" size="mini" prop="boss" class="w-50" :disabled="disabled2"   style="width: 100px;">
               <el-option
                      v-for="item in splist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
               </el-radio>
             
            </el-form-item>
              </div>
          </el-radio-group>
            <table class="table table-bordered myTable">
                <tr>
                  <td width="50%">
                     <el-form-item :label="$t('nav.아이디')" prop="mem_id" class="mb-0 formItem">
                        <el-input v-model="userform.mem_id" class="w-75"></el-input>
                     </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.사용자암호')" prop="mem_pw" class="mb-0 formItem">
                    <el-input v-model="userform.mem_pw" class="w-75"></el-input>
                  </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                     <el-form-item :label="$t('msg.닉네임')" prop="mem_name" class="mb-0 formItem">
                        <el-input v-model="userform.mem_name" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('msg.핸드폰')" class="mb-0 formItem" prop="mem_hp">
                            <el-input v-model="userform.mem_hp" class="w-75"></el-input>
                          </el-form-item>
                  </td>
                </tr>
                 <template v-if="(this.sitetype==='1' || this.sitetype==='3' || this.sitetype==='4') && this.power=='1'">
                <tr>
                  <td>
                     <el-form-item :label="$t('msg.파워볼일반')" class="mb-0 formItem" prop="event_loing">
                      <el-input v-model="userform.event_loing" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.파워볼조합')" class="mb-0 formItem" prop="event_loing_group">
                        <el-input v-model="userform.event_loing_group" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                </tr>
                <!--<tr>
                  <td>
                     <el-form-item label="사다리 일반" class="mb-0 formItem" prop="event_loing_s">
                        <el-input v-model="userform.event_loing_s" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                      <el-form-item label="사다리 조합" class="mb-0 formItem" prop="event_loing_group_s">
                        <el-input v-model="userform.event_loing_group_s" class="w-75"></el-input>
                      </el-form-item>
                  </td>
                </tr>-->
                 </template>
                   <template v-if="this.bg==='1' ">
                    <tr>
                      <td>
                    <el-form-item :label="$t('msg.보글파일반')" class="mb-0 formItem" prop="event_loing1">
                      <el-input v-model="userform.event_loing1" class="w-75"></el-input>
                    </el-form-item>
                    </td>
                    <td>
                    <el-form-item :label="$t('msg.보글파조합')" class="mb-0 formItem" prop="event_loing_group1">
                      <el-input v-model="userform.event_loing_group1" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                  </tr>
                   <tr>
                      <td>
                    <el-form-item :label="$t('msg.보글사일반')" class="mb-0 formItem" prop="event_loing_s1">
                      <el-input v-model="userform.event_loing_s1" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    
                    <el-form-item :label="$t('msg.보글사조합')" class="mb-0 formItem" prop="event_loing_group_s1">
                      <el-input v-model="userform.event_loing_group_s1" class="w-75"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                    </template>
                     <template v-if="this.sitetype==='4'">
                      <tr>
                        <td>
                           <el-form-item label="카지노롤링" class="mb-0 formItem" prop="event_loing_e">
                              <el-input v-model="userform.event_loing_e" class="w-75"></el-input>
                            </el-form-item>
                        </td>
                        <td>
                          <el-form-item  :label="$t('msg.슬롯롤링')" class="mb-0 formItem" prop="event_loing_slot">
                              <el-input v-model="userform.event_loing_slot" class="w-75"></el-input>
                            </el-form-item>
                        </td>
                      </tr>
                     
                      
                     
                     </template>
                     <tr>
                       <td>
                           <el-form-item :label="$t('tableText.출금비번')" class="mb-0 formItem" prop="mem_jumin">
                          <el-input v-model="userform.mem_jumin" class="w-75"></el-input>
                        </el-form-item> 
                       </td>
                       <td>
                          <el-form-item :label="$t('tableText.은행명')" class="mb-0 formItem" prop="mem_bankcode">
                            <el-input v-model="userform.mem_bankcode" class="w-75"></el-input>
                          </el-form-item>
                       </td>
                     </tr>
                      <tr>
                       <td>
                         <el-form-item :label="$t('tableText.계좌번호')" class="mb-0 formItem" prop="mem_banknum">
                            <el-input v-model="userform.mem_banknum" class="w-75"></el-input>
                          </el-form-item>
                       </td>
                       <td>
                         <el-form-item :label="$t('tableText.예금주')" class="mb-0 formItem" prop="mem_bankname">
                            <el-input v-model="userform.mem_bankname" class="w-75"></el-input>
                          </el-form-item>
                       </td>
                     </tr>
                     

            </table>

          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submitForm" :disabled="disabled">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>
       
</div>
 </template>

 <script>
  import layer from '../../components/common/layer.vue';
 import layoutLayer from '../../components/common/layout-layer.vue';
 import layerNew from '../../components/common/layer-new.vue';

    export default {
     components: {
      layer,layoutLayer,layerNew
    },
    	data(){
    		return{
          searchform:{
           
            time:[],
            searchOptions:[
                
            {
              label:this.$i18n.t("tableText.마스터선택"),
              value:'m_code'
            },{
              label:this.$i18n.t("tableText.본사선택"),
              value:'s_code'
            },

            ],
             searchOptions1:[


             ],
            
            value:'',
            value1:'',
            


          },
          currentRowId:'',
          admin_id:'',
          layoutWidth1:'600px',
          dWidth:'400px',
          radio:'1',
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          bg:window.sessionStorage.getItem('bg'),
          userid:window.sessionStorage.getItem('userid'),
           aid:window.sessionStorage.getItem('admin_id'),
            power:window.sessionStorage.getItem('power'),
          disabled:false,
          disabled1:false,
          layLoading:false,

          disabled2:true,
          formLoading:false,
          idDialogVisible: false,
          total:0,
          size:0,
          currentPage:1,
          editIndex:-1,
           adminlist:[{
                 label:this.$i18n.t("status.선택"),
                value:''
            },
            
            ],
             bubonOptlist:[{
                label:this.$i18n.t("msg.정상"),
                value:'1'
            },
            {
                label:this.$i18n.t("msg.차단"),
                value:'0'
            }
            
            ],
       
          options: [{
               label:this.$i18n.t("msg.블랙"),
              value: '-2',
             
            }, {
              label:this.$i18n.t("msg.대기"),
               value: '-1',
              
            }, {
             label:this.$i18n.t("msg.기본"),
               value: '0',
             
            }, {
              label: 'v1',
               value: '1',
             
            }, {
              label: 'v2',
               value: '2',
             
            }, {
              label: 'v3',
               value: '3',
             
            }, {
              label: 'v4',
               value: '4',
             
            }, {
              label: 'v5',
               value: '5',
             
            }],
   
    			loading:false,
          order:'descending',
          prop:'mem_idx',
    			data: [],
          creatModel:false,
           statusOptions:[
             {
              label:this.$i18n.t("msg.정상"),
              value:'1'
            },
             {
             label:this.$i18n.t("msg.차단"),
              value:'0'
            },
            {
              label:this.$i18n.t("status.선택"),
              value:''
            },

            ],
            bubonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],
            splist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],
          userform:{
            agent_name:'',
            shop_name:'',
             a_code:'',
             c_code:'',
            mem_pw:'',
            mem_name:'',
            mem_id:'',
             id:'',
            
            event_loing_recom:'',
            event_loing_recom_s:'',
            event_loing_group_recom:'',
            event_loing_group_recom_s:'',

            event_loing:'',
            event_loing_group:'',
            event_loing_s:'',
            event_loing_group_s:'',



            event_loing_recom1:'',
            event_loing_recom_s1:'',
            event_loing_group_recom1:'',
            event_loing_group_recom_s1:'',

            event_loing1:'',
            event_loing_group1:'',
            event_loing_s1:'',
            event_loing_group_s1:'',


            event_loing_e:'',
            event_loing_slot:'',
           


              mem_banknum:'',
            mem_bankcode:'',
            mem_bankname:'',
            mem_jumin:'',
            mem_hp:'',
           
            status:'',
           
          },
           io_type:'',
            ioType: [
               {
                label: this.$i18n.t("msg.충전"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.환전"),
                 value: '2',
               
              }],
               pickerOptions: {
          },
         shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          form:{
            mem_id:'',
            money:'',
            memo:'',
            admin_id:'',
          },
           options1: [{
               
                 label: this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }],
           gubun:'',
          dialogModel:false,
           rules: {
                  mem_jumin:[{ required: true, message: '', trigger: 'blur'}],
                  
                  event_loing_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom_s:[{ required: true, message: '', trigger: 'blur'}],

                  event_loing:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_s:[{ required: true, message: '', trigger: 'blur'}],

                  event_loing_e:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_slot:[{ required: true, message: '', trigger: 'blur'}],

                  //agent_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankname:[{ required: true, message: '', trigger: 'blur'}],
                  mem_hp:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankcode:[{ required: true, message: '', trigger: 'blur'}],
                  mem_banknum:[{ required: true, message: '', trigger: 'blur'}],
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  mem_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_pw:[{ required: true, message: '', trigger: 'blur'}],
                  //a_code:[{ required: true, message: '', trigger: 'blur'}],
                },
         
         
		             

      }
    },
    			
    			
    		
    	created(){
         let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/user/bubonlist_select?type=bossnull&admin=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
           let newids=[];

            let obj={};
            obj.label=this.$i18n.t("msg.없음")
            obj.value=''
            newids.push(obj); 

            newids=[];

            


            response.data.admin.forEach(item=>{
            let obj={};
            obj.label=item.name
            obj.value=item.name
            newids.push(obj);            
           });


           

           this.adminlist=newids
    
            }).catch((error) =>{
              
            })

        if(this.sitetype=="3")
        {
                this.options1=[{
               
                label: this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.이벤트머니"),
                 value: '2',
               
              }, {
                label: this.$i18n.t("msg.롤링머니"),
                 value: '3',
               
              }];
        }

        //console.log( this.$route.params.rand)

    		this.getList()
    	},

    	methods:{
     rowClick(row, column, event) {
          this.currentRowId=row.mem_id
           console.log('row',row)
           
           
          },


         
        adminChange(v){
          //console.log(v)
          this.admin_id=v
          this.getList()
        },
      searchEvent(){

                if(this.searchform.value == ''){
                  this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                   return;
                }
          this.getList();
        },
        bonOpen(e,id,type){
            this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layoutLayer,
                parent: this,
                data:{
                einfo:{e:e},
                info:{id:id,type:type},
                layerid:'id'
                }
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['500px', '480px'],
        });
        
        },
       
        radioChange(val){
          //console.log('val',val)
          this.disabled2 = (val==='1') ? true : false
          this.disabled1 = (val==='2') ? true : false
        },
        openUserModel(e = false){
          let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/user/zplist_select?shop=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
               //  console.log(response.data.data);

                 let newids=[];

                 let newids2=[];


           response.data.data.forEach(item=>{
            let obj={};
            obj.label=item.code
            obj.value=item.code
            newids.push(obj);
           });


          this.bubonlist=newids

          response.data.data2.forEach(item=>{
            let obj={};
            obj.label=item.code
            obj.value=item.code
            newids2.push(obj);
           });


          this.splist=newids2

                 
                  
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })

            //console.log('add');
            this.userform = {
                  agent_name:'',
                  shop_name:'',
                  a_code:'',
                  c_code:'',
                  mem_pw:'',
                  mem_name:'',
                  mem_id:'',
                  event_loing_group_recom:'',
                  event_loing_group_recom_s:'',
                  event_loing_recom:'',
                  event_loing_recom_s:'',

                    event_loing1:0,
                          event_loing_s1:0,
                          event_loing_group1:0,
                          event_loing_group_s1:0,

                  mem_banknum:'',
                  mem_bankcode:'',
                  mem_bankname:'',
                  mem_jumin:'',
                  mem_hp:'',
                  status:'1'
                  

                 }

          this.creatModel = true
        },
        submitForm(){
              let token=window.sessionStorage.getItem('user');
              //a_code c_code 2-1
              if(!this.userform.a_code && !this.userform.c_code)
              {
                 this.$message({
                    message:this.$i18n.t("msg.총판또는매장선택해주세요"),
                    type: 'warning'
                  });
                  return;
              }
              this.$refs.userform.validate((e)=>{
             if(!e) return;

                 this.disabled = true
                 this.loading =true
                 this.$axios({
                        method:'post',
                        url:this.domain+'/user/user_insert',
                        data:{
                        
                          a_code:this.userform.a_code,
                          c_code:this.userform.c_code,
                          mem_pw:this.userform.mem_pw,
                          mem_name:this.userform.mem_name,
                          id:this.userform.idx,
                          mem_id:this.userform.mem_id,

                          event_loing:this.userform.event_loing,
                          event_loing_s:this.userform.event_loing_s,
                          event_loing_group:this.userform.event_loing_group,
                          event_loing_group_s:this.userform.event_loing_group_s,

                          event_loing1:this.userform.event_loing1,
                          event_loing_s1:this.userform.event_loing_s1,
                          event_loing_group1:this.userform.event_loing_group1,
                          event_loing_group_s1:this.userform.event_loing_group_s1,


                          event_loing_e:this.userform.event_loing_e,
                          event_loing_slot:this.userform.event_loing_slot,
                       
                          mem_banknum:this.userform.mem_banknum,
                          mem_bankcode:this.userform.mem_bankcode,
                          mem_bankname:this.userform.mem_bankname,
                          mem_jumin:this.userform.mem_jumin,
                          mem_hp:this.userform.mem_hp
                          
                         
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                                  message:response.data.msg,
                                  type: 'warning'
                                });
                                
                            }else{
                               this.$message({
                                  message:response.data.msg,
                                  type: 'success'
                                });
                               //console.log(this.form);
                               this.getList();
                         
                              this.creatModel = false

                            }
                           this.loading =false
                           this.disabled = false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                       this.loading =false
                           this.disabled = false
                  })
              
            
            })
              
            
        },
      
         // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
        openModel(id){

          if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: '',
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                area: ['830px', '680px'],
             
             });
              return;
           }
           
          this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        },
        tableSortChange(column) {
 
         this.prop= column.prop
         this.order= column.order
         
        this.getList()
     },
    		handleNodeClick(data) {
		        console.log(data);
		      },
    		 handleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.size = val
              this.getList();
              this.loading= true

            },
            handleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.currentPage = val
              this.getList();
              this.loading= true
            },
    		getList(){

          

           this.loading = true
    			 let token=window.sessionStorage.getItem('user');

    			 this.loading = true;
    				//console.log(token);
    			 // let urls=api.admin;
    			this.$axios({
	                method:'get',
	                // url:api.admin+'/api/user/mem_cp_list2?fit='+this.prop+'&order='+this.order,
                   url:this.domain+'/user/memlist?admin_id='+this.admin_id+'&fit='+this.prop+'&order='+this.order,
	                'Accept': 'application/json',
	                headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 


            	     let data = response.data.data
            	   //  console.log('usersdata:',response.data.data)
            	     this.data = data
                   this.total = data.total
                   this.currentPage = data.current_page
                   this.size =data.per_page
                   this.loading = false
                     
               
            }).catch((error) =>{
                 console.log('error',error.response)   //请求失败返回的数据

                  this.$message.error(error);
              this.loading = false

            })
    		},
    		changeOptions(e){
               let token=window.sessionStorage.getItem('user');
               this.$axios({
                    method:'post',
                    url:this.domain+'/user/mem_level_up',
                    data:{
                       level:e.row.memState,
                       id:e.row.mem_id
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                         this.$message({
                      message:this.$i18n.t("msg.완료"),
                      type: 'success'
                    });
                          
                      }else{
                         this.$message.error(this.$i18n.t("msg.실패"));

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
    		
    	// 批量删除
      deleteAll(e){
        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');
   

          this.$axios({
                      method:'post',
                      url:this.domain+'/user/mem_del?mem_id='+e.row.mem_id,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }
                    else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                     this.loading = false
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message:this.$i18n.t("msg.취소됨")
          });          
        });

        
      },  
    		
    	}
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }

 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px;

 }
 >>>.formItem2 label.el-form-item__label{
    color: #444 !important;
    text-align: left;
    padding-left: 5px;
    line-height: 36px;

 }
 /deep/ .el-table__body tr.current-row>td.el-table__cell {
   
    background-color: #f3eba3!important;
}

</style>



// WEBPACK FOOTER //
// src/views/user/list.vue